import { useAuth } from 'auth';
import OverlaySection from 'components/Overlays/OverlaySection/OverlaySection';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext } from 'react';
import { getDateWithTimeStr } from 'utils/format';

const RequestedBySection: React.FC = () => {
  const { userId } = useAuth();
  const { state: appState } = useContext(AppStoreContext);
  const currentUser = appState.users.find((u) => userId === u.id);

  const project = appState.getProject();

  if (!project || !currentUser) {
    return null;
  }

  const submittingName = `${currentUser.profile.firstname} ${currentUser.profile.lastname}`;

  const hasSubmittingCompany = currentUser.profile.company.length > 0;
  const hasSubmittingName =
    `${currentUser.profile.firstname}${currentUser.profile.lastname}`.length >
    0;
  const hasSubmittingEmail = currentUser.email.length > 0;

  return (
    <OverlaySection label="Requested by" tabMode>
      {hasSubmittingName ? (
        <div className="truncate">{submittingName}</div>
      ) : null}
      {hasSubmittingEmail ? (
        <div className="truncate">{currentUser.email}</div>
      ) : null}
      {hasSubmittingCompany ? (
        <div className="truncate">{currentUser.profile.company}</div>
      ) : null}
      <div>{getDateWithTimeStr(Date.now() / 1000)}</div>
    </OverlaySection>
  );
};

export default RequestedBySection;
